import api from "@/lib/api";

export const BACKUP_DONE_EVENT = "sensofon:backup-done";
const CHUNK_SIZE = 512 * 1024;
const pad = (n) => String(n).padStart(2, "0");

export const formatBackupDate = (iso) =>
  iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export async function downloadBackup() {
  const { data } = await api.get("/backup/export", { responseType: "blob", timeout: 180000 });
  const d = new Date();
  const name = `sensofon-backup-${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}.json.gz`;
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
  window.dispatchEvent(new Event(BACKUP_DONE_EVENT));
  return name;
}

export async function restoreBackup({ file, email, password, onProgress }) {
  const begin = new FormData();
  begin.append("email", email);
  begin.append("password", password);
  begin.append("total_size", String(file.size));
  const { data: { upload_id } } = await api.post("/backup/restore/begin", begin);
  const total = Math.ceil(file.size / CHUNK_SIZE);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", upload_id);
    fd.append("index", String(i));
    fd.append("chunk", file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE), "chunk.bin");
    await api.post("/backup/restore/chunk", fd, { timeout: 60000 });
    onProgress?.(Math.round(((i + 1) / total) * 85));
  }
  const fd = new FormData();
  fd.append("upload_id", upload_id);
  const { data } = await api.post("/backup/restore/commit", fd, { timeout: 300000 });
  onProgress?.(100);
  return data;
}
